import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Angular Material
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

// Components
import { RelatedPartyPaymentTypeComponent } from './components/related-party-payment-type/related-party-payment-type.component';
import { RelatedPartyPaymentAddComponent } from './components/related-party-payment-add/related-party-payment-add.component';
import { RelatedPartyPaymentDeleteComponent } from './components/related-party-payment-delete/related-party-payment-delete.component';
import { RelatedPartyPaymentAllocationComponent } from './components/related-party-payment-allocation/related-party-payment-allocation.component';
import { M3PayorAllocateComponent } from './components/m3-payor-allocate/m3-payor-allocate.component';

// Service
import { RelatedPartyPaymentService } from './services/related-party-payment.service';
import { M3PayorAllocateService } from './components/m3-payor-allocate/m3-payor-allocate.service';

@NgModule({ declarations: [
        RelatedPartyPaymentTypeComponent,
        RelatedPartyPaymentAddComponent,
        RelatedPartyPaymentDeleteComponent,
        RelatedPartyPaymentAllocationComponent,
        M3PayorAllocateComponent
    ],
    exports: [
        RelatedPartyPaymentTypeComponent,
        RelatedPartyPaymentAddComponent,
        RelatedPartyPaymentDeleteComponent,
        RelatedPartyPaymentAllocationComponent,
        M3PayorAllocateComponent
    ], imports: [CommonModule,
        FormsModule,
        MatSnackBarModule,
        MatAutocompleteModule], providers: [
        RelatedPartyPaymentService,
        M3PayorAllocateService
    ] })
export class RelatedPartyPaymentModule { }

